module.exports = __webpack_public_path__ + "static/img/9.07bf8f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ajbz/9.png
// module id = fjJH
// module chunks = 0